
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.496 5.548c.157-.219.335-.451.537-.702.925-1.148 1.572-2.445 1.674-3.22.08-.606.048-1.18-.048-1.434.34.106 1.173.433 1.785 1.657.613 1.224.893 2.933.957 3.634.149 0 .605-.334.749-.7.175-.447.207-1.085.207-1.085.638.595 1.212 3.003 1.15 4.293-.013.26-.031.47-.056.647a3.977 3.977 0 01-.974 2.202c-.312.386-.71.71-1.19.921A3.994 3.994 0 01.764 9.657a2.627 2.627 0 01-.148-.454A4 4 0 01.49 8.146c-.004-.323.033-.63.127-.949.16-.621.466-1.184.88-1.65z","fill":"#EE4F23"}})])
          )
        }
      }
    